import { AnyObject } from "@commonlibs";
import ObjectStorageRepository from "./ObjectStorageRepository";

export default abstract class ObjectSessionStorageRespository<T extends AnyObject> extends ObjectStorageRepository<T> {
    constructor(key: string) {
        super(key, sessionStorage);
    }
}
